import {computed} from "vue";

export function useMatchingHash(props, route) {
  return computed(() => {
    const propsHash = props?.hash;
    console.log(`useMatchingHash: propsHash = ${propsHash}`);
    const currentHash = route.hash.slice(1);
    console.log(`useMatchingHash: currentHash = ${currentHash}`);
    if (!propsHash || !currentHash) return false;
    console.log(`useMatchingHash: both defined: propsHash and currentHash`);
    if (typeof propsHash === "string") return propsHash === currentHash;
    if (propsHash instanceof RegExp) return propsHash.test(currentHash);
    return false;
  });
}
